import { Button } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";
import React from "react";
interface InternalNotesModalProps {
  toggleInternalNotesModal: () => void;
  internalNotesRef: React.MutableRefObject<null>;
}
const InternalNotesModal = ({
  toggleInternalNotesModal,
  internalNotesRef
}: InternalNotesModalProps) => {
  return <div ref={internalNotesRef} className={cls("flex flex-col fixed left-0 top-0 w-[95%] max-w-[720px] h-full bg-white z-[999]", "bg-clip-padding transition-transform duration-200 delay-200 ease-in-out shadow-lg")} data-testid="internal-notes-modal" data-sentry-component="InternalNotesModal" data-sentry-source-file="InternalNotesModal.tsx">
      <div className="flex flex-row px-4 py-[22px] border-t-0 border-x-0 border-b border-solid border-gray-300">
        <span className="font-bold text-xl text-gray-800">Merchant Plans</span>
        <Button theme="wss" variant="tertiary" size="large" color="gray" iconProps={{
        name: "ri-close-line"
      }} onClick={toggleInternalNotesModal} aria-label="Close Internal Notes Modal" className="absolute p-0 right-4 self-center" data-testid="close-internal-notes-modal" data-sentry-element="Button" data-sentry-source-file="InternalNotesModal.tsx"></Button>
      </div>
    </div>;
};
export default InternalNotesModal;